export default "__VITE_ASSET__D$mPaH$u__"